import { AsyncActionType } from '../../data/utils';

export const ACTIVATE_ACCOUNT = new AsyncActionType('ACTIVATE', 'ACCOUNT');
export const ACTIVATE_ACCOUNT_FORM_DATA = 'ACTIVATE_ACCOUNT_FORM_DATA';
export const ACTIVATE_ACCOUNT_NOT_FOUND = 'ACTIVATE_ACCOUNT_NOT_FOUND';

export const activateAccount = usernameEmail => ({
  type: ACTIVATE_ACCOUNT.BASE,
  payload: { usernameEmail },
});

export const activateAccountBegin = () => ({
  type: ACTIVATE_ACCOUNT.BEGIN,
});

export const activateAccountSuccess = usernameEmail => ({
  type: ACTIVATE_ACCOUNT.SUCCESS,
  payload: { usernameEmail },
});

export const activateAccountForbidden = () => ({
  type: ACTIVATE_ACCOUNT.FORBIDDEN,
});

export const activateAccountServerError = () => ({
  type: ACTIVATE_ACCOUNT.FAILURE,
});

export const activateAccountNotFound = (errorMessage, errorCode) => ({
  type: ACTIVATE_ACCOUNT_NOT_FOUND,
  payload: { errorMessage, errorCode },
});

export const setActivateAccountFormData = (activateAccountFormData) => ({
  type: ACTIVATE_ACCOUNT_FORM_DATA,
  payload: { activateAccountFormData },
});
